module.exports = __webpack_public_path__ + "img/total4.a346d553.png";